import * as lexi from "lexicographic-integer";

export const Sort = {
  encode(index: number): string {
    return lexi.pack(index, "hex");
  },
  decode(lexidx: string): number {
    return lexi.unpack(lexidx);
  },
};
